import React, { useMemo } from "react";
import styles from "./index.module.scss";
import open from "../../../img/open.png";
import close from "../../../img/close.png";
import moment from "moment";
import "moment/locale/zh-cn";
import { NoticeListItem } from "API";
import PlatformWrap from "../../../../../components/PlatformWrap";
import { readableDate } from "../../../../../Utils/filter";

interface ListItemProps {
    active: boolean;
    data: NoticeListItem;
    onClick: () => void;
}

const NoticeItem = ({ active, data, onClick }: ListItemProps) => {
    const dataTime = useMemo(
        () => readableDate(data.createTime),
        [data.createTime]
    );

    return (
        <div className={styles.root}>
            <div className={styles.container} onClick={onClick}>
                <div
                    className={styles.info}
                    style={{
                        color: data.readStatus === "0" ? "#666" : "#999"
                    }}>
                    <PlatformWrap
                        pc={
                            <span className={styles.time}>
                                {moment(data.createTime).format(
                                    "YYYY-MM-DD HH:mm:ss"
                                )}
                            </span>
                        }
                        mobile={<span className={styles.time}>{dataTime}</span>}
                    />
                    <div
                        className={styles.sender}
                        style={{
                            color: data.readStatus === "0" ? "#666" : "#999"
                        }}>
                        发件人：{data.createUser}
                    </div>
                </div>
                <img
                    src={data.readStatus === "0" ? close : open}
                    className={styles.img}
                />
                <div>
                    <div
                        className={styles.title}
                        style={{
                            color: data.readStatus === "0" ? "#333" : "#999"
                        }}>
                        {data.title}
                    </div>
                </div>
            </div>
            <div
                className={styles.target}
                style={{ display: active ? "block" : "none" }}>
                通知内容：
                <br />
                <div
                    className={styles.body}
                    style={{ display: active ? "inline-block" : "none" }}
                    dangerouslySetInnerHTML={{ __html: data.content }}
                />
            </div>
        </div>
    );
};
export default NoticeItem;
